// extracted by mini-css-extract-plugin
export var actionButton = "_ri-0";
export var actionMenuContainer = "_ri-i";
export var bubble = "_ri-2";
export var bubbleActionMenu = "_ri-j";
export var bubbleContext = "_ri-6";
export var bubbleItems = "_ri-7";
export var customer = "_ri-3";
export var divider = "_ri-8";
export var fileList = "_ri-9";
export var hiddenComment = "_ri-o";
export var infoAbove = "_ri-a";
export var internal = "_ri-4";
export var lightActionButton = "_ri-1";
export var link = "_ri-b";
export var merchant = "_ri-5";
export var message = "_ri-c";
export var profilePicture = "_ri-e";
export var quillToolbarContainer = "_ri-f";
export var senderDate = "_ri-g";
export var senderDateCustomer = "_ri-h";
export var senderName = "_ri-d";
export var time = "_ri-k";
export var uploadedImage = "_ri-l";
export var username = "_ri-m";
export var xsmall = "_ri-n";